<template>
  <div id="OpenDateManage">
    <div style="padding: 0 0.5rem 0.5rem;">
      <b-button variant="primary" tabindex="98"
        @click="save()"><b-icon icon="check"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>&nbsp;&nbsp;

    </div>
    <div class='well'
      style="margin-bottom:0; position: relative; overflow: auto; max-height: 29rem; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
      <table v-if="inputData != null" style="border:2.5px solid; padding:5px; width:100%;" rules="all" cellpadding='5'
       >
        <tbody style="line-height:1.5rem;">

          <tr style="height:30.5em;">
            <td class="ncut-edit-form-text label-td">申請開放期間：</td>
            <td class="ncut-base-form-ipt text-td" colspan="5">
              <table>
                <tr>
                  <td>
                    <datetime  type="datetime"  format="yyyy-MM-dd HH:mm" tabindex="1"
                              v-model="inputData.date1"
                              :phrases="{ok: '確定', cancel: '取消'}"
                              class="theme-orange"
                              :week-start="7"
                              auto></datetime>

                  </td>
                  <td>
                    &nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                  </td>
                  <td>

                    <datetime  type="datetime"  format="yyyy-MM-dd HH:mm" tabindex="2"
                              v-model="inputData.date2"
                              :phrases="{ok: '確定', cancel: '取消'}"
                              class="theme-orange"
                              :week-start="7"
                              auto></datetime>

                  </td>
                </tr>
              </table>
            </td>
          </tr>


        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

export default {
  name: 'OpenDateManage',
  props: [
    'id'
  ],
  components: {
    datetime: Datetime
  },
  data () {
    return {
      date:['',''],
      datetimeEmpty:null,
      isIE: false,
      inputData: {
        date1:new Date(),
        date2:new Date(),

      },
      }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    getToday(updateTime) {
      var dd = new Date(updateTime);
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}-{1}-{2}", yyyy, mm, today);
    },

    checkSaveData () {
      let msg = '';

      if (tools.isNullOrEmpty(this.inputData.date1)) {
        msg = '申請開放起始日';
      } else if (tools.isNullOrEmpty(this.inputData.date2)) {
        msg = '申請開放結束日';
      }
      return msg;
    },
    save () {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;

        // vm.inputData.date1=new Date(vm.inputData.date1);
        // vm.inputData.date2=new Date(vm.inputData.date2);

        this.$http.put('./WebApi/SportsExcellent/SetTimeSet/', this.inputData)
          .then((response) => {
            if ( response.data) {
                tools.showAlert(vm, 'success', '恭喜您,存檔成功');
                vm.getTimeSet();

            }
            else {
                tools.showAlert(vm, 'danger', '對不起,存檔失敗');
            }
          })
          .catch(function (error) {
              tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入'.concat(msg).concat('!'));
      }
    },
//     getISOString: function (dt) {
// // getMonth回傳值為0-11, 所以加1
// var date = null;
// if (null != dt) {
// if (typeof dt == "string") {
// date = new Date(dt);
// } else {
// date = dt;
// }
// return date.toISOString();
// }
//     },

    getTimeSet: function () {
      var vm = this
      this.$http.get('./WebApi/SportsExcellent/GetTimeSet/')
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data[0];



          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error);
        })

    },

  },
  created () {
    console.log('======created OpenDateManageView =====');
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge") > -1;
this.getTimeSet();
var d=new Date();
this.inputData.date1=d.toISOString();
this.inputData.date2=d.toISOString();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
